import {
  convertDotcmsResponseToRecord,
  convertDotcmsString,
  convertDotcmsStringNonNullable,
} from './converters-from-dotcms';
import type { IBaseObjectData } from './dotcms-base-object';
import type { IGqlHelper } from './gql-helper';

export type ILoginButtonSign = {
  loginRoleLabel: string | undefined;
  logoutRoleLabel: string | undefined;
};

export type IHeaderSectionData = IBaseObjectData & {
  myAccountLinkSign: string | undefined;
  switchToAdminViewLinkText: string;
  loginButtonLabels: ILoginButtonSign;
};

export const HeaderGqlHelper: IGqlHelper<IHeaderSectionData> = {
  contentTypeName: 'HeaderSection',
  gqlFieldsQuery: `
    myaccountlinksign
    switchToAdminViewLinkText
    loginbuttonlabels {
      loginrolelabel
      logoutrolelabel
    }
  `,
  processGqlData: (gqlResponse: unknown) => {
    if (!gqlResponse) {
      return undefined;
    }

    const { myaccountlinksign, loginbuttonlabels, switchToAdminViewLinkText } =
      convertDotcmsResponseToRecord(gqlResponse);

    return {
      myAccountLinkSign: convertDotcmsString(myaccountlinksign),
      switchToAdminViewLinkText: convertDotcmsStringNonNullable(
        switchToAdminViewLinkText,
      ),
      loginButtonLabels: {
        loginRoleLabel: convertDotcmsString(
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          loginbuttonlabels?.loginrolelabel,
        ),
        logoutRoleLabel: convertDotcmsString(
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          loginbuttonlabels?.logoutrolelabel,
        ),
      },
    };
  },
};
